import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgOrderedListIcon = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M2.5 18.3327V17.0827H4.58333V16.4577H3.33333V15.2077H4.58333V14.5827H2.5V13.3327H5C5.23611 13.3327 5.43403 13.4125 5.59375 13.5723C5.75347 13.732 5.83333 13.9299 5.83333 14.166V14.9993C5.83333 15.2355 5.75347 15.4334 5.59375 15.5931C5.43403 15.7528 5.23611 15.8327 5 15.8327C5.23611 15.8327 5.43403 15.9125 5.59375 16.0723C5.75347 16.232 5.83333 16.4299 5.83333 16.666V17.4993C5.83333 17.7355 5.75347 17.9334 5.59375 18.0931C5.43403 18.2528 5.23611 18.3327 5 18.3327H2.5ZM2.5 12.4993V10.2077C2.5 9.97157 2.57986 9.77365 2.73958 9.61393C2.89931 9.45421 3.09722 9.37435 3.33333 9.37435H4.58333V8.74935H2.5V7.49935H5C5.23611 7.49935 5.43403 7.57921 5.59375 7.73893C5.75347 7.89865 5.83333 8.09657 5.83333 8.33268V9.79101C5.83333 10.0271 5.75347 10.225 5.59375 10.3848C5.43403 10.5445 5.23611 10.6243 5 10.6243H3.75V11.2493H5.83333V12.4993H2.5ZM3.75 6.66602V2.91602H2.5V1.66602H5V6.66602H3.75ZM7.5 15.8327V14.166H17.5V15.8327H7.5ZM7.5 10.8327V9.16602H17.5V10.8327H7.5ZM7.5 5.83268V4.16602H17.5V5.83268H7.5Z",
		fill: "#636566"
	})]
});
const ForwardRef = forwardRef(SvgOrderedListIcon);
export { ForwardRef as ReactComponent };
